import React from 'react'
import Header from '../../components/header/Header'

const Introduce = () => {
  return (
    <div>
      <Header/>
    </div>
  )
}

export default Introduce